/** @format */

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideSectionService,
  setId,
  ToggleEdit,
  toggleRender,
} from "../../../store/stateSlice";
import Popup from "../../global/form create/Popup";
import UploadPhoto from "../../inputs/UploadPhoto";
import InputField from "../../inputs/inputField";
import InputSelect from "../../inputs/InputSelect";
import SelectField from "../../inputs/SelectField";
import {
  addCategory,
  postCategory,
  setCategoryID,
  setEdit,
} from "../../../store/category";
import { Spinner1 } from "../../spinners/Spinner1";
import { useEffect } from "react";
import { getOne } from "../../../store/helper";
import { render } from "@testing-library/react";
import { alertMsg } from "../../../utilities/helper";
import pc from "../../../Assets/images/ahmedeldesoky.jpeg";
const NewSection = () => {
  //view pupup when onclick "اضافة مجموعة خدمات جديدة"
  const viewPupup = useSelector((state) => state.toggleState.value.newSection);
  const dispatch = useDispatch();
  const hidePupup = () => {
    resetValues();
    dispatch(setCategoryID({ id: null }));
    dispatch(hideSectionService());
  };
  // handel data form
  const categoryState = useSelector((state) => state.category);
  // const appState = useSelector((state) => state.toggleState.value);
  const [state, setState] = useState("");

  const [values, setValues] = useState({
    render: false,
    photo: null,
    viewPhoto: "",
    users: [],
    en_name: "",
    ar_name: "",
    cat_status: {},
  });

  // State to store uploaded file
  const [file, setFile] = useState("");

  useEffect(() => {
    if (categoryState.id) {
      dispatch(
        getOne({
          path: "/categories/",
          id: categoryState.id,
        })
      )
        .unwrap()
        .then((res) => {
          const { name_en, name_ar, image, status } = res.data;
          setValues({
            render: true,
            en_name: name_en,
            ar_name: name_ar,
            photo: image,
            cat_status: state,
            status: status,
          });
          setState(status);
          setFile("");

          dispatch(setEdit({ edit: false }));
        });
    } else {
      resetValues();
    }
  }, [categoryState.id]);
  const resetValues = () => {
    setValues({
      render: false,
      photo: null,
      viewPhoto: "",
      users: [],
      en_name: "",
      ar_name: "",
      cat_status: {},
    });
    setState("");
    setFile("");
  };
  // Handles file upload event and updates state
  function handleUpload(e) {
    const file = e.target.files[0];
    setValues({ ...values, photo: file });
  }
  // console.log(values.file);
  function handleChange({ target }) {
    setValues({
      ...values,
      [target.name]: target?.value,
    });
  }

  //function to sumbit data
  const handleSubmit = (e) => {
    e.preventDefault();

    let valuesClone = { ...values };

    valuesClone.status = state?.value ?? state;
    if (
      !valuesClone.ar_name ||
      !valuesClone.en_name ||
      !valuesClone.photo ||
      !valuesClone.status
    ) {
      alertMsg("جميع البيانات مطلوبة", false);
    } else {
      if (categoryState.id) {
        dispatch(
          postCategory({
            ...valuesClone,
            method: "PUT",
            id: categoryState.id,
          })
        ).then((res) => {
          if (res.payload.response?.data?.status === "error") {
          } else {
            if (categoryState.success) {
              hidePupup();
              dispatch(hideSectionService());
              dispatch(setCategoryID({ id: null }));
              resetValues();
              // dispatch(toggleRender());
            }
          }
        });
      } else {
        dispatch(
          postCategory({
            ...valuesClone,

            method: "POST",
            id: null,
          })
        ).then((res) => {
          if (res.payload.data.status === "error") {
          } else {
            resetValues();
            if (categoryState.success) {
              hidePupup();
              dispatch(toggleRender());
              dispatch(hideSectionService());
              setValues({ ...values, render: true });
              dispatch(toggleRender());
            }
          }
        });
      }
    }
  };
  return (
    <Popup viewPupup={viewPupup} hidePupup={hidePupup} viewWidth='content-lg'>
      {categoryState.loading && <Spinner1 />}

      <form className='main-contnt' onSubmit={handleSubmit}>
        <div className='head-content'>
          <UploadPhoto
            name='NewSection'
            handleUpload={handleUpload}
            file={file}
            image={values.photo}
          />

          {/* <div className="view-img">
            <img src={pc} alt="" />
          </div> */}
        </div>

        <InputSelect
          value={state}
          name='status'
          label='حالة القسم'
          onChange={(value) => setState(value)}
          options={[
            { label: "نشطة", value: "active" },
            { label: "غير نشطة ", value: "inactive" },
          ]}
          placeholder='اختر حالة المجموعة'
          note='*'
        />
        <div className='body-content'>
          <InputField
            value={values.ar_name}
            name='ar_name'
            onChange={handleChange}
            title='اسم الخدمة باللغة العربية'
            placeholder='اكتب اسم المجموعة'
            note='*'
          />
          <InputField
            value={values.en_name}
            name='en_name'
            onChange={handleChange}
            title='اسم الخدمة باللغة الانجليزية'
            placeholder='اكتب اسم المجموعة'
            note='*'
          />
        </div>
        <div className='buttons-contnt display-flex center-flex '>
          <input value='اضافه' type='submit' class='btn btn__primary' />
          <div class='btn btn__danger' onClick={hidePupup}>
            الغاء
          </div>
        </div>
      </form>
    </Popup>
  );
};

export default NewSection;
